<template>
    <div class="unit-types-selector-wrapper">
        <div class="unit-types-selector">
            <div class="custom-unit-type-wrapper"
                :class="{
                    ['selected']: unitTypeIsSelected(unitType),
                    ['readonly']: readonly,
                }"
                v-for="unitType of unitTypes" :key="`custom-unit-type-${unitType}`"
                @click="toggleSelectedUnitType(unitType)"
            >
				<unit-image :unitType="unitType" class="custom-unit-type" />
                <fa-icon
                    icon="asterisk"
                    class="icon note-top"
                    v-if="showRemarks && [UNIT_TYPE_EARL, UNIT_TYPE_HERALD].includes(unitType)"
                />
                <icon icon="fort" class="icon note-top fort-icon" v-if="showRemarks && unitType === UNIT_TYPE_SAPPER"/>
                <fa-icon
                    icon="feather"
                    class="icon mastery-expansion-icon"
                    v-if="showRemarks && masteryUnitTypes.includes(unitType)"
                />
                <span class="royal-guard-marker"  v-if="markRoyalGuards && unitType === UNIT_TYPE_ROYAL_GUARD">
                    1.0
                </span>
                <span class="royal-guard-marker" v-if="markRoyalGuards && unitType === UNIT_TYPE_ROYAL_GUARD_NOBILITY"
                    >2.0
                </span>
            </div>
        </div>
        <div class="same-team-toggle-wrapper" v-if="onToggleSameTeam" :class="{ checked: unitsOnSameTeam }">
            <span class="same-team-toggle-label">
                {{unitsOnSameTeam ? 'Same team' : 'Any team'}}
            </span>
            <switch-toggle
                :icon="unitsOnSameTeam ? 'check' : ''"
                :checked="unitsOnSameTeam"
                :callback="onToggleSameTeam"
                :altColors="true"
            />
        </div>
    </div>
</template>

<script>
import { getAssetUrl } from '../../helpers/assets';
import {
    UNIT_TYPE_EARL,
    UNIT_TYPE_HERALD,
    UNIT_TYPE_SAPPER,
    UNIT_TYPE_ROYAL_GUARD,
    UNIT_TYPE_ROYAL_GUARD_NOBILITY,
    masteryUnitTypes,
} from '../Unit/Unit-types';

export default {
    name: 'UnitTypesSelector',
    props: [
        'onChange',
        'selectedUnitTypes',
        'nobilityExpansion',
        'readonly',
        'siegeExpansion',
        'unitTypes',
        'showRemarks',
        'markRoyalGuards',
        'onToggleSameTeam',
        'unitsOnSameTeam',
    ],
    data() {
        return {
            ['UNIT_TYPE_EARL']: UNIT_TYPE_EARL,
            ['UNIT_TYPE_HERALD']: UNIT_TYPE_HERALD,
            ['UNIT_TYPE_SAPPER']: UNIT_TYPE_SAPPER,
            ['UNIT_TYPE_ROYAL_GUARD']: UNIT_TYPE_ROYAL_GUARD,
            ['UNIT_TYPE_ROYAL_GUARD_NOBILITY']: UNIT_TYPE_ROYAL_GUARD_NOBILITY,
            masteryUnitTypes,
        };
    },
    methods: {
        getAssetUrl,
        toggleSelectedUnitType(unitType) {
            if (this.readonly) {
                return;
            }

            let selectedUnitTypes = [...this.selectedUnitTypes];

            if (selectedUnitTypes.includes(unitType)) {
                selectedUnitTypes = selectedUnitTypes.filter(selectedUnitType =>
                    selectedUnitType !== unitType);
            } else if (
                [UNIT_TYPE_EARL, UNIT_TYPE_HERALD].includes(unitType) &&
                !this.nobilityExpansion
            ) {

                this.$notify({
                    group: 'app',
                    type: 'info',
                    text: 'This unit is only available with the Nobility Expansion',
                });
            } else if (
                unitType === UNIT_TYPE_SAPPER &&
                !this.siegeExpansion
            ) {

                this.$notify({
                    group: 'app',
                    type: 'info',
                    text: 'This unit is only available with the Siege Expansion',
                });
            } else {
                selectedUnitTypes.push(unitType);
            }

            this.onChange(selectedUnitTypes);
        },
        unitTypeIsSelected(unitType) {
            return this.selectedUnitTypes.includes(unitType);
        },
    },
};
</script>

<style lang="scss">
    @use "@/styles/styles.scss" as *;

    .unit-types-selector-wrapper {

        .same-team-toggle-wrapper {
            display: flex;
            font-size: .85rem;
            justify-content: flex-end;
            padding: 0 32px;

            &.checked {

                .same-team-toggle-label {
                    color: $green;
                }
            }

            .same-team-toggle-label {
                color: $sage-brown;
                font-family: 'RobotoSlab', 'Avenir', Helvetica, Arial, sans-serif;
            }

            > * {
                align-self: center;
            }
        }

        .unit-types-selector {
            display: flex;
            flex-wrap: wrap;
            justify-content: center;

            .custom-unit-type-wrapper {
                cursor: pointer;
                position: relative;

                &.readonly {
                    cursor: default;
                }

                &.selected {

                    .custom-unit-type,
                    .icon,
                    .royal-guard-marker {
                        opacity: 1;
                    }
                }

                .custom-unit-type {
                    height: auto;
                    margin: 3px;
                    max-height: 30px;
                    max-width: 30px;
                    width: auto;
                    opacity: .5;
                }

                .icon {
                    position: absolute;
                    border-radius: 4px;
                    color: $dark-blue;
                    padding: 1px 2px;
                    font-size: .6em;
                    opacity: .5;

                    .icon-label {
                        line-height: 1em;
                        vertical-align: middle;
                    }

                    &.fort-icon {
                        height: auto;
                        max-height: 6px;
                        max-width: 10px;
                        width: auto;

                        &.note-top {
                            right: -3px;
                        }
                    }

                    &.note-bottom {
                        right: -2px;
                        bottom: -1px;
                    }

                    &.note-top {
                        right: -2px;
                        top: -1px;
                    }


                    &.mastery-expansion-icon {
                        right: -3px;
                        top: -2px;
                    }
                }

                .royal-guard-marker {
                    background: white;
                    border-radius: 4px;
                    border: 1px solid gray;
                    color: gray;
                    font-size: .6em;
                    font-weight: bold;
                    opacity: .65;
                    padding: 0 2px;
                    position: absolute;
                    right: -2px;
                    top: 0;
                }
            }
        }
    }

    .matches {

        .unit-types-selector-wrapper {
            background: white;
            box-shadow: -1px 1px 3px 2px rgba(120,120,120,0.35);
            border-radius: 6px;

            .unit-types-selector {
                padding: 12px 25px 0;
            }
        }
    }

</style>
